import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { Trans } from 'lingui-react';

import getComplaintText from 'utils/complaint';

import { CardElement } from 'elements/Card';
import Popover, {
  PopoverTarget,
  PopoverContent,
  ScrollingPopoverContentWrapper,
} from 'elements/Popover';

import TextDiv from 'elements/TextDiv';

import messages from './messages';

function Complaint({ caseInfo }) {
  const { title, content } = getComplaintText(caseInfo.toJS(), { titleInLink: false });

  return (
    <CardElement>
      <Popover showOnHover>
        <PopoverTarget>
          <TextDiv modifiers={['bold', 'bottomGap', 'smallText']}>
            <Trans id={messages.complaintTitle} />
          </TextDiv>
          <TextDiv modifiers={['bottomGap', 'heavyText', 'ellipsis', 'oneLine', 'smallText']}>
            {title}
          </TextDiv>
          <TextDiv modifiers={['ellipsis', 'midGreyText', 'short', 'smallText']}>
            {content}
          </TextDiv>
        </PopoverTarget>
        <PopoverContent>
          <ScrollingPopoverContentWrapper modifiers={['smallText']}>
            <TextDiv modifiers={['bold', 'bright', 'bottomGap']}>
              {title}
            </TextDiv>
            <TextDiv modifiers={['bottomGap']}>
              {content}
            </TextDiv>
          </ScrollingPopoverContentWrapper>
        </PopoverContent>
      </Popover>
    </CardElement>
  );
}

Complaint.propTypes = {
  caseInfo: ImmutablePropTypes.contains({
    complaint: PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    }),
    description: PropTypes.string,
  }).isRequired,
};

export default Complaint;



// WEBPACK FOOTER //
// ./components/CaseDisplayElement/Complaint.js